import { render, staticRenderFns } from "./SystemLogs.vue?vue&type=template&id=58ba5052&scoped=true&"
import script from "./SystemLogs.vue?vue&type=script&lang=js&"
export * from "./SystemLogs.vue?vue&type=script&lang=js&"
import style0 from "./SystemLogs.vue?vue&type=style&index=0&id=58ba5052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ba5052",
  null
  
)

export default component.exports